export const join = (array, separator) => array.filter(v => v).join(separator);

export const capitalize = value => {
	if (!value) return "";
	value = value.toString();
	return value.charAt(0).toUpperCase() + value.slice(1);
};

export const capitalizeEach = stringWithSpaces => {
	return stringWithSpaces
		.split(" ")
		.map(word => {
			return capitalize(word);
		})
		.join(" ");
};

export const formatDateString = (str, exp, sub) => {
	var regexp = new RegExp(exp, "g");
	return formatOnlyDate(str)
		.toString()
		.replace(regexp, sub);
};

import moment from "moment";
import _ from "lodash";

export const addTime = (value, number, typeString) => {
	return moment(value).add(number, typeString);
};

export const areDatetimesTheSame = (value, comparator) => {
	return moment(value).isSame(comparator, "day");
};

export const daysBetween = (from, to) => {
	return moment(to).diff(moment(from), "d");
};

export const subTime = (value, number, typeString) => {
	return moment(value).subtract(number, typeString);
};

export const fromNow = value => moment(value).fromNow();

export const formatDate = (v, formatString) =>
	moment(v).format(formatString || "M/D/YY h:mm A");

export const formatOnlyDate = (v, formatString) =>
	moment(v).format(formatString || "MM/DD/YYYY");

export const formatOnlyTime = (v, formatString) =>
	moment(v).format(formatString || "hh:mm");

export const json = v => JSON.stringify(v, null, 2);

export const ellipsis = (str, len) => {
	if (typeof str === "string" && str.length > len) {
		return str.substring(0, len - 3) + "\u2026";
	}
	return str;
};

export const formatUTCtoLocal = inputDate => {
	let localDateTime = null;

	const UNSPECIFIED = "Unspecified";
	if (_.isNil(inputDate)) {
		return UNSPECIFIED;
	}

	// Ensure inputDate is a string.
	if (typeof inputDate != "string") {
		inputDate = inputDate.toISOString();
	}

	if (isIsoFormattedString(inputDate)) {
		// If we have confirmed this is in ISO format,
		// then conform the string so that it parses correctly.
		const conformedString = conformDateString(inputDate);
		localDateTime = new Date(conformedString);
	} else {
		localDateTime = new Date(inputDate);
	}

	if (!_.isNil(localDateTime) && localDateTime != "Invalid Date") {
		let zone = localDateTime
			.toLocaleTimeString("en-us", { timeZoneName: "short" })
			.split(" ")[2];
		if (!zone) {
			var parts = localDateTime.toTimeString().match(/\(([^)]+)\)/i);
			var timezone = parts[1];
			if (timezone.search(/\W/) >= 0) {
				timezone = timezone
					.match(/\b\w/g) // Match first letter at each word boundary.
					.join("")
					.toUpperCase();
			}
			return moment(localDateTime).format("MM/DD/YYYY, h:mm a ") + timezone;
		} else return moment(localDateTime).format("MM/DD/YYYY, h:mm a ") + zone;
	} else return UNSPECIFIED;
};

export const formatLocalToUTC = inputDate => {
	if (!_.isNil(inputDate)) {
		return new Date(inputDate).toUTCString();
	} else return null;
};

const isIsoFormattedString = inputDate => {
	if (_.isNil(inputDate)) {
		return false;
	}

	// We need this to be a string
	if (typeof inputDate != "string") {
		inputDate = inputDate.toISOString();
	}

	// Date().toJSON() creates a 24 char string, like "yyyy-mm-ddThh:mm:ss.000Z".
	inputDate = conformDateString(inputDate);

	const jsonFormat = new Date(inputDate).toJSON();
	return inputDate == jsonFormat;
};

/**
 * conformDateString just adds zeros and Z to end of a shorter string,
 * to make the length 24 chars. This could do with some refinement,
 * but works for current scenario where API returns shorter ISO string.
 */
const conformDateString = inputString => {
	if (inputString.length > 23) {
		return inputString;
	}

	// if inputString is only "yyyy-mm-ddThh:mm:ss", then add a period
	// before padding with zeros.
	if (inputString.length === 19) {
		inputString += ".";
	}

	// Add zeros until string length = 23.
	while (inputString.length < 23) {
		inputString += "0";
	}

	// Add Z at end.
	inputString += "Z";
	return inputString;
};
